import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Component imports
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AgentFleetSection from '../components/AgentFleetSection';
import PillarsSection from '../components/PillarsSection';
import IntegrationsSection from '../components/IntegrationsSection';
import ChatbotSdkPreview from '../components/ChatbotSdkPreview';
import FeaturesSection from '../components/FeaturesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

// Data imports
import { PILLARS, FEATURES, APP_CONFIG } from '../data/content';

// Utility imports
import { scrollToSection, getCurrentYear } from '../utils/helpers';

const HomePage = () => {
  const [currentYear, setCurrentYear] = useState('');
  const location = useLocation();

  useEffect(() => {
    setCurrentYear(getCurrentYear());
  }, []);

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const targetSection = location.state.scrollTo;
      window.history.replaceState({}, document.title);
      setTimeout(() => {
        scrollToSection(targetSection);
      }, 150);
    } else if (location.hash) {
      const hashId = location.hash.substring(1);
      setTimeout(() => {
        scrollToSection(hashId);
      }, 150);
    }
  }, [location]);

  return (
    <div className="bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100 min-h-screen font-inter antialiased selection:bg-brand-500/30 selection:text-brand-200 transition-colors duration-300">
      <Header 
        projectName={APP_CONFIG.projectName} 
        onNavigate={scrollToSection} 
      />

      <main>
        {/* Hero Section with Interactive Multi-Agent DAG Simulator */}
        <HeroSection 
          projectName={APP_CONFIG.projectName} 
          tagline={APP_CONFIG.tagline} 
        />

        {/* 6 Specialized Core Agents Fleet */}
        <AgentFleetSection />

        {/* Core Technology Pillars & Architecture Tabs */}
        <PillarsSection pillars={PILLARS} />

        {/* Extensible SaaS Tool Registry & Postman Onboarding */}
        <IntegrationsSection />

        {/* Live Embeddable Chatbot SDK & Interactive Widget Preview */}
        <ChatbotSdkPreview />

        {/* Enterprise Features: Zero-Trust Multi-Tenancy & Performance */}
        <FeaturesSection features={FEATURES} projectName={APP_CONFIG.projectName} />

        {/* Customer Impact & Validation */}
        <TestimonialsSection />

        {/* Call to Action Banner */}
        <CTASection onNavigate={scrollToSection} />

        {/* Demo Booking & Technical Briefing Form */}
        <ContactSection />
      </main>

      <Footer 
        projectName={APP_CONFIG.projectName} 
        currentYear={currentYear} 
      />
    </div>
  );
};

export default HomePage;
